import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { CONTACT } from "@/lib/api";

const LINKS = [
  { label: "Bulk Food", href: "#calculator" },
  { label: "Catering", href: "#packages" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#footer" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background/90 backdrop-blur-md border-b border-border" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-6xl px-5 h-16 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" onClick={(e) => { e.preventDefault(); go("#top"); }}
           className="flex items-center">
          <img src="/logo.png" alt="The Quisine — Cloud Kitchen & Caterers" className="h-11 w-auto object-contain" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button key={l.href} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              onClick={() => go(l.href)}
              className="text-sm text-foreground/70 hover:text-primary transition-colors">
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="hamburger-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden grid place-items-center w-11 h-11 rounded-full border border-border bg-card"
          aria-label="Menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden bg-background border-b border-border"
          >
            <div className="px-5 py-4 flex flex-col">
              {LINKS.map((l) => (
                <button key={l.href} data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ", "-")}`}
                  onClick={() => go(l.href)}
                  className="py-3 text-left font-serif text-2xl text-primary border-b border-border/60 last:border-0">
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
